// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import ProductList from '../../../component/ProductList';
import { AlternateBlock, BackButtonWrapper, BackButton } from '../styles/AnimatedListView.style';

const AnimatedListView = ({
  showList,
  backToLook,
  productList,
  isFullRowView,
  isAnimatedList,
  shopButtonText,
  aspectRatioObj,
  animationProps,
  isAnimateToLeft,
  handleBackToLook,
  isCarouselDesign,
  isOneColumnFullRow,
  onQuickViewOpenClick,
  carouselFlipListSize,
  adobeAnalyticsProps,
  tileHeight,
  shouldAllowMaxHeight,
  isOtherPagesSetup,
  productTileHeight,
}) => {
  const { isFlipAnimation, isSlideAnimation } = animationProps;
  return (
    <AlternateBlock
      showList={showList}
      className="flip-list-container"
      aspectRatioObj={aspectRatioObj}
      isAnimatedList={isAnimatedList}
      isAnimateToLeft={isAnimateToLeft}
      isCarouselDesign={isCarouselDesign}
      isSlideInAnimation={isFlipAnimation}
      isSlideOutAnimation={isSlideAnimation}
      isOneColumnFullRow={isOneColumnFullRow}
      carouselFlipListSize={carouselFlipListSize}
      tileHeight={tileHeight}
      isFullRowView={isFullRowView}
      shouldAllowMaxHeight={shouldAllowMaxHeight}
      isOtherPagesSetup={isOtherPagesSetup}
      productTileHeight={productTileHeight}
    >
      <ProductList
        isMobileView={false}
        productList={productList}
        isFullRowView={isFullRowView}
        aspectRatioObj={aspectRatioObj}
        shopButtonText={shopButtonText}
        isCarouselDesign={isCarouselDesign}
        carouselFlipListSize={carouselFlipListSize}
        onQuickViewOpenClick={onQuickViewOpenClick}
        showList={showList}
        adobeAnalyticsProps={adobeAnalyticsProps}
      />
      <BackButtonWrapper className="flip-list-back-button">
        <BackButton onClick={handleBackToLook}>{backToLook}</BackButton>
      </BackButtonWrapper>
    </AlternateBlock>
  );
};

AnimatedListView.propTypes = {
  showList: PropTypes.bool,
  isFullRowView: PropTypes.bool,
  isAnimatedList: PropTypes.bool,
  isAnimateToLeft: PropTypes.bool,
  isCarouselDesign: PropTypes.bool,
  isOneColumnFullRow: PropTypes.bool,
  aspectRatioObj: PropTypes.shape({}),
  backToLook: PropTypes.string.isRequired,
  handleBackToLook: PropTypes.func.isRequired,
  shopButtonText: PropTypes.string.isRequired,
  onQuickViewOpenClick: PropTypes.func.isRequired,
  productList: PropTypes.PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  animationProps: PropTypes.shape({
    isFlipAnimation: PropTypes.bool,
    isSlideAnimation: PropTypes.bool,
  }),
};

AnimatedListView.defaultProps = {
  showList: false,
  aspectRatioObj: {},
  isFullRowView: false,
  isAnimatedList: false,
  isAnimateToLeft: false,
  isCarouselDesign: false,
  isOneColumnFullRow: false,
  animationProps: {
    isFlipAnimation: false,
    isSlideAnimation: false,
  },
};

export default AnimatedListView;
